// Shared "did the user answer anything?" test for the SCS wizard payloads.
//
// The wizard pages keep their repeatable blocks on screen even once every
// answer in them has been cleared, so a page the user emptied still builds a
// payload of empty sections. The backend wants nothing at all in that case, so
// each page runs its built payload through emptyWhenUnanswered() before saving.
//
// `ignoredKeys` names the answers that cannot be cleared on screen — a button
// group offers no way to un-pick the option that was selected — so a payload
// holding nothing but those is still an empty page.

export const hasWizardAnswer = (payload, ignoredKeys = []) => {
  const ignored = new Set(ignoredKeys);
  const walk = value => {
    if (Array.isArray(value)) return value.some(walk);
    if (value && typeof value === "object") {
      return Object.entries(value).some(
        ([key, entry]) => !ignored.has(key) && walk(entry)
      );
    }
    if (typeof value === "string") return value.trim() !== "";
    // null / undefined is unanswered, and so is `false`: the Yes/No questions
    // only report something once they are answered "Yes".
    return value !== null && value !== undefined && value !== false;
  };
  return walk(payload);
};

// What to save: the built payload, or {} when the page holds no answer.
export const emptyWhenUnanswered = (payload, ignoredKeys) =>
  hasWizardAnswer(payload, ignoredKeys) ? payload : {};
